module.exports = __webpack_public_path__ + "images/emoji/surfer.58f4e48047002305b31b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/surfer.png
// module id = soY4
// module chunks = 14